import { useContext } from 'react';
import logo from '../../assets/img/logo.svg';
import { AppContext } from '../../context/Contexte';
const Powered = () => {
  const { t } = useContext(AppContext);
  return (
    <>
      <div className="powered">
        <div className="flex">
          <a href="https://www.sowelab.com/">
            <p>Powered by</p>
            <img src={logo} alt="Sowelab" className="logo" />
          </a>
        </div>
        <a href="https://www.sowelab.com/pages/contact">{t('powered_text')}</a>
      </div>
    </>
  );
};

export default Powered;
